import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import TanzakuCard from './TanzakuCard';
import './TanzakuDisplay.css';

const TanzakuDisplay = ({ tanzaku, onTanzakuClick, onTanzakuLiked, onTanzakuPositionChange }) => {
  const [localTanzaku, setLocalTanzaku] = useState(tanzaku);

  // 親のtanzakuが更新されたらlocalTanzakuも更新
  React.useEffect(() => {
    setLocalTanzaku(tanzaku);
  }, [tanzaku]);

  const handlePositionChange = (tanzakuId, newPosition) => {
    // ローカル状態を即座に更新（アニメーションなし）
    setLocalTanzaku(prev => 
      prev.map(t => 
        t.id === tanzakuId 
          ? { ...t, position_x: newPosition.x, position_y: newPosition.y }
          : t
      )
    );
    
    // 親コンポーネントには次フレームで通知（レンダリング完了後）
    requestAnimationFrame(() => {
      if (onTanzakuPositionChange) {
        onTanzakuPositionChange(tanzakuId, newPosition);
      }
    });
  };

  // 短冊を新しい順にソート
  const sortedTanzaku = [...localTanzaku].sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12
      }
    }
  };

  return (
    <div className="tanzaku-display">
      <div className="display-header">
        <div className="display-title">
          <h2>みんなの願い事</h2>
          <p>{tanzaku.length}個の短冊が飾られています</p>
        </div>
      </div>

      {sortedTanzaku.length === 0 ? (
        <div className="no-tanzaku">
          <p>まだ短冊がありません。最初の願い事を書いてみましょう！</p>
        </div>
      ) : (
        <motion.div
          className="tanzaku-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <AnimatePresence>
            {sortedTanzaku.map((t, index) => (
              <motion.div
                key={t.id}
                initial={false}
                layout={false}
                layoutId={false}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ 
                  default: { duration: 0 },
                  exit: { duration: 0.3 }
                }}
                style={{
                  position: 'absolute',
                  left: `${t.position_x}%`,
                  top: `${t.position_y}%`,
                  zIndex: sortedTanzaku.length - index,
                  willChange: 'transform'
                }}
              >
                <TanzakuCard
                  tanzaku={t}
                  onClick={() => onTanzakuClick(t)}
                  onLiked={onTanzakuLiked}
                  onPositionChange={handlePositionChange}
                  isDraggable={true}
                />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      )}
    </div>
  );
};

export default TanzakuDisplay;